export function isPartiallyFormattedTelephoneNumber(str) {
  // `|$` is a trick to match a partial string
  return /^(\d|$){2}(\s)?(\d|$){2}(\s)?(\d|$){2}(\s)?(\d|$){2}$/.test(str);
}
//# sourceMappingURL=helpers.js.map